<template>
	<div class="m-portlet m-portlet--mobile m-portlet-bet-report">
		<div class="m-portlet__head row">
			<div class="col-12 filter">
				<div class="row">
			<!-- 		<div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 type">
						<div class="row"> -->
							<div class="col-2">
								<div class="input-group">
									<select class="form-control" v-model="game_selected">
										<option value="-1">Miền</option>
										<option v-for="(game, id) in gameInfo.games" v-bind:value="id">
											{{game}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-2">
								<div class="input-group">
									<select class="form-control" v-model="channel_selected">
										<option value="-1">Đài</option>
										<option v-for="channel in channel_list" v-bind:value="channel.id">
											{{channel.text}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-2">
								<div class="input-group">
									<select class="form-control" v-model="prop_selected">
										<option value="-1">Kiểu</option>
										<option v-for="id in prop_list" v-bind:value="id">
											{{gameInfo.props[id]}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-1">
								<button type="reset" class="btn btn-primary" v-on:click="fetchData()">Lọc</button>
							</div>
						<!-- </div>
					</div> -->
				</div>
				<div class="m-separator m-separator--dashed"></div>
			</div>
			<div class="col-12 breadcrumbs">
				<ul class="m-nav m-nav--inline">
                    <li class="m-nav__item" v-for="breadcrumb in levelsActive" v-on:click="onLevelChange(breadcrumb)">
                        <a class="m-nav__link">
                            <span>{{breadcrumb}}</span>
                            <span class="m-nav__separator">/</span>
                        </a>
                    </li>
                    <li class="m-nav__item">
                        <a class="m-nav__link deactive">
                            <span>{{levelsDeactive}}</span>
                        </a>
                    </li>
				</ul>
			</div>
		</div>
		<div class="m-portlet__body">
			<router-view 
				:data="reportData"
			/>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { Utilities } from "../../utilities";
	import { mapGetters } from 'vuex';

	const propsInfo = {
		1: [1,2,4,6,7,9,11,12,14,15,16],
		2: [1,2,3,5,6,7,8,10,11,13,14,15,16],
		3: [17,18,19],
		4: [1,2,3,5,6,7,8,10,11,13,14,15,16],
	};

	export default {
		data() {
			return {
				"levelsActive": [],
				"levelsDeactive": "",
				"level": "",
				"game_selected" : -1,
				"channel_selected" : -1,
				"prop_selected" : -1,
				"channel_list" : [],
				"prop_list" : [],
				"channels_by_game" : [],
				"reportData" : []
			}
		},
		created() {
			let router = {name: 'BetReportTotalRaw', params: { code: "admin" } };
			router["params"] = (this.user.role == "admin" || this.user.code == "") ? { code: "admin" } : { code: this.user.code };

			this.$router.replace(router);
		},
	    mounted () {
    		this.groupChannelByGame();
	    },
	    beforeRouteUpdate(to, from, next){	
	    	if((from.name == "BetReportTotalRaw" && to.name == "BetReportDetailRaw") || from.name == "BetReportDetailRaw" && to.name == "BetReportTotalRaw"){
	    		let tables = $.fn.dataTable.tables();
	    		tables.forEach((e) => {
	    			$(e).DataTable().destroy();
	    		});
	    	}

	    	if(!to.params.smsId){
		    	this.level = to.params.code;
		    	this.fetchData();
	    	}else{
		    	this.level = to.params.code;
		    	this.fetchData(to.params.smsId);
	    	}
		    next();
	    },
		watch:{
	    	game_selected: function(s){
	    		this.channel_selected = -1;
	    		this.prop_selected = -1;
	    		if(s == -1){
	    			this.channel_list = [];
	    			this.prop_list = [];
	    		}else{
		    		this._generateAll(s);
		    		this.prop_list = propsInfo[s];
	    		}
	    	}
		},
		computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},
		methods: {
	        onLevelChange: function(level){
	        	this.level = level;

				let router = {name: 'BetReportTotalRaw', params: { code: level } };
				this.$router.push(router);
	        },

			fetchData: async function(smsId = null){
				if(!this.level) return;

				let res = smsId ? 
							await axios.get("admin-panel/report/raw/"+this.level+"/"+smsId+"?game="+this.game_selected+"&channel="+this.channel_selected+"&prop="+this.prop_selected) :
				 			await axios.get("admin-panel/report/raw/"+this.level+"?game="+this.game_selected+"&channel="+this.channel_selected+"&prop="+this.prop_selected);
				res = res.data;

				if(res.code == 0){

					this.reportData = res.data.report;

					var breadcrumbs = res.data.breadcrumb;
					var levelsActive = [];
					for(let i in breadcrumbs){
						var b = breadcrumbs[i];
						if((parseInt(i)+1) == breadcrumbs.length){
							this.levelsDeactive = b;
						}else{
							levelsActive.push(b);
						}
					}
					this.levelsActive = levelsActive;
				}
			},
	        groupChannelByGame: function() {
	        	let channels  = {};
	        	for(let i in this.gameInfo.channels){
	        		let channel = this.gameInfo.channels[i];

	        		if(!channels[channel.game_id]) channels[channel.game_id] = [];
	        		channels[channel.game_id].push(channel);
	        	}

	        	this.channels_by_game = channels;
	        },
	        _generateAll: function(game){
	        	let vm = this;
	        	let data = [];

				if(game == 3){
        			data = vm.gameInfo.xienChannels.map((e) => {
        				return {
        					"id": e,
        					"text": e.split(".").map((el) => { return vm.gameInfo.channels[el].alias; }).join(" - ")
        				}
        			});
        		}else{
        			data = vm.channels_by_game[game].map((e) => { return { "id": e.id, "text": e.alias } });

		        	if(game == 1){
		        		vm.channel_selected = 36;
		        	}
        		}
        		vm.channel_list = data;
	        },
		}
	}
</script>